// ajax模块
export default {
  'ERR500.tips':
    'Something went wrong. Developers have been informed about this and will correct the issue. Please try again later. Thank you.'
};
